import { render, staticRenderFns } from "./select-shop.vue?vue&type=template&id=6b00078c&scoped=true"
import script from "./select-shop.vue?vue&type=script&lang=js"
export * from "./select-shop.vue?vue&type=script&lang=js"
import style0 from "./select-shop.vue?vue&type=style&index=0&id=6b00078c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00078c",
  null
  
)

export default component.exports